<script>
export default {
  name: 'SSelect',
  model: {
    prop: 'value',
    event: 'change'
  },
  created () {
    // this.updateState(this.value)
  },
  mounted () {
    if (this.value) {
      console.log(this.value)
      this.updateState(this.value)
    }
    document.addEventListener('click', this.globalClickListener)
    if (this.$slots.default) {
      this.$slots.default.forEach(vnode => {
        vnode.componentInstance.$on('change', this.updateValue)
        this.listened = true
        this.children = this.$slots.default.map(vnode => vnode.componentInstance)
      })
    }
  },
  updated () {
    if (this.$slots.default) {
      this.$slots.default.forEach(vnode => {
        const index = this.children.findIndex(item => {
          return item === vnode.componentInstance
        })
        // 防止重复监听
        if (index === -1) {
          vnode.componentInstance.$on('change', this.updateValue)
        }
      })
      this.children = this.$slots.default.map(vnode => vnode.componentInstance)
    }
  },
  beforeDestroy () {
    document.removeEventListener('click', this.globalClickListener)
  },
  watch: {
    value (value) {
      this.$nextTick(() => {
        console.log(value)
        this.updateState(value)
      })
    },
    $slot () {
      console.log('slot')
    }
  },
  render () {
    return (
      <div class="custom-select" ref="select">
        <div class="main-select" onClick={this.select.bind(this)} data-uid={this._uid}>
          <span class="selected-text">{ this.label }</span>
          <div class="arrow"></div>
        </div>
        <div
          class="options"
          style={{ top: '100%', display: this.visible ? 'block' : 'none' }}
          onMouseenter={this.onmouseenter.bind(this)}
          onMouseleave={this.onmouseleave.bind(this)}
          onClick={this.select.bind(this)}
        >
          {this.$slots.default}
        </div>
      </div>
    )
  },
  props: {
    value: {
      required: false,
      default: undefined
    }
  },
  data () {
    return {
      offsetTop: 0,
      visible: false,
      label: '',
      mouseenter: false,
      index: 0,
      listened: false,
      children: []
    }
  },
  methods: {
    updateState (value) {
      console.log(this.$slots)
      if (this.$slots.default) {
        console.log(value)
        const selectedChildComponent = this.$slots.default.find(vnode => {
          return vnode.componentInstance.value === value
        }).componentInstance
        console.log(selectedChildComponent)
        if (selectedChildComponent) {
          this.label = selectedChildComponent.$slots.default[0].text
        }
      }
    },
    updateValue (value) {
      console.log(value)
      this.$emit('change', value)
    },
    globalClickListener (e) {
      // console.log(e.target)
      // console.log(e.target.dataset)
      // console.log(this._uid)
      if (`${this._uid}` !== e.target.dataset.uid) {
        this.visible = false
      }
    },
    select (e) {
      // if (e) {
      //   e.stopPropagation()
      // }
      if (e.target !== e.currentTarget) {
        e.stopPropagation()
      }
      this.visible = !this.visible
    },
    onmouseenter () {
      this.mouseenter = true
    },
    onmouseleave () {
      this.mouseenter = false
    }
  }
}
</script>
<style lang="less" scoped>
  .custom-select {
    position: relative;
    width: 460px;
    height:52px;
    background-color: #fff;
    border: 1px solid #8d5a5a;
    padding: 0 14px;
    cursor: pointer;
    .main-select {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 100%;
      .selected-text {
        font-family: SimHei;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333;
      }
      .arrow {
        width: 0;
        height: 0;
        border: 7px solid #6b1919;
        border-bottom-width: 5px;
        border-right-color: transparent;
        border-bottom-color: transparent;
        border-left-color: transparent;
        margin-top: 10px;
      }
    }
    .options {
      display: none;
      position: absolute;
      left: 0;
      width: 100%;
      max-height: 300px;
      overflow-y: scroll;
      border: solid 1px #595956;
      z-index: 99;
      border-style: solid;
      border-width: 1px;
    }
  }
  @media screen and (max-width: 750px) {
    .custom-select {
      width: 70.6667rem;
      height: 8.2667rem;
      padding: 0 2.1333rem;
      .main-select {
        .selected-text {
          font-size: 2.6667rem;
          letter-spacing: 0;
        }
        .arrow {
          border: 1.733333rem /* 13/7.5 */ solid #454545;
          border-right-color: transparent;
          border-bottom-color: transparent;
          border-left-color: transparent;
          margin-top: 1.333333rem /* 10/7.5 */;
        }
      }
      .options {
        width: 70.6667rem;
        left: -1px;
        font-size: 2.6667rem ;
      }
    }
  }
</style>
